import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../../api.service';
@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.css']
})
export class AdminHeaderComponent implements OnInit {
  displayBasic: boolean;
  login_detail:any;
  notificationsList: any = [];
  PTPcount: any;
  displayPTPDialog: boolean = false;
  constructor(
    private router: Router,
    private _api: ApiService,
    @Inject(SESSION_STORAGE) private storage: StorageService
  ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.login_detail = this.getFromLocal("login_detail");
    this._api.getnotifcations_list(this.login_detail._id).subscribe(data=>{
      if (data['Code'] == 200) {
        this.notificationsList = data['Data'];
      } else {
        this.notificationsList = [];
      }
    });

    const data = {
      user_id: this.login_detail._id
    }
    this._api.getPTPcount(data).subscribe(data=>{
      this.PTPcount = data['Data']?.count;
    });
  }

  getNotifications(){
    this.displayPTPDialog = true;
  }

  showPTPDetails() {
    this.displayPTPDialog = false;
    console.log('Navigating to dashboard...');
    this.router.navigate(['/admin_panel/dashboard']).then(() => {
      console.log('Navigation successful');
      setTimeout(() => {
        this.storage.set('showPTPDetails', true);
        this.storage.set('expandWorkflowRelated', true);
        console.log('Storage flags set');
      }, 100);
    }).catch(err => {
      console.error('Navigation error:', err);
    });
  }

  saveInLocal(key, val): void {
    this.storage.set(key, val);
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }
  showBasicDialog() {
    this.displayBasic = true;
}
  onInput(event){
    this.router.navigateByUrl('admin_panel/search-results');
  }

logout(){
  this.router.navigate(['']);
  this.storage.clear();
}
}
